import { Methods } from "@newview/infrastructure";
import {NewviewOaBaseApi} from "./NewviewOaBaseApi";


export class EmployeeExtendApi extends NewviewOaBaseApi {

  public get ControllerName(): any {
    return 'employee-extend'
  }

}